import { SimpleGrid, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect } from "react";

import { QuestCard } from "../../components/quest-card";

import { LatestQuestCard } from "./LatestQuestCard";

import { PageLayout } from "@/components/page-layout";
import { LATEST_QUEST_BANNER_ID } from "@/constants/shared";
import { useHomeBanner } from "@/hooks/useHomeBanner";
import { useQuests } from "@/hooks/useQuests";
import { Quest } from "@/types";

export const Quests = () => {
  const { dismissBannerId } = useHomeBanner();

  useEffect(() => {
    dismissBannerId(LATEST_QUEST_BANNER_ID);
  }, [dismissBannerId]);
  const { allQuests, headerQuest } = useQuests();

  const sortedQuests = allQuests?.sort((a, b) =>
    dayjs(a.wave).diff(dayjs(b.wave)),
  );

  const liveQuests = sortedQuests?.filter(
    (quest) => quest.id !== headerQuest?.id && !quest.isSunset,
  );
  const discontinuedQuests = sortedQuests?.filter(
    (quest) => quest.id !== headerQuest?.id && quest.isSunset,
  );

  return (
    <PageLayout
      title="Level Up"
      tertiaryTitle="Complete quests, learn about Plume, earn yields and Plume Points!"
    >
      {headerQuest && <LatestQuestCard quest={headerQuest} />}
      {liveQuests.length > 0 && (
        <Text fontSize="2xl" fontWeight="700" lineHeight="32px" mt={4}>
          Live Quests
        </Text>
      )}
      <QuestGrid quests={liveQuests} />
      {discontinuedQuests.length > 0 && (
        <Text fontSize="2xl" fontWeight="700" lineHeight="32px" mt={4}>
          Discontinued
        </Text>
      )}
      <QuestGrid quests={discontinuedQuests} />
    </PageLayout>
  );
};

const QuestGrid = ({ quests }: { quests: Quest[] }) => {
  if (quests.length === 0) return null;
  return (
    <SimpleGrid
      columns={{
        base: 1,
        md: 1,
        lg: 2,
        xl: 3,
        "2xl": 3,
      }}
      gap={6}
      w="full"
    >
      {quests.map((quest) => (
        <QuestCard key={quest.id} quest={quest} source="quests-page" />
      ))}
    </SimpleGrid>
  );
};
